export default "__VITE_ASSET__bxMCytsd__"